/**
 * Rotten Charm — Carousel arrow controls
 * The track itself is natively scrollable (touch/trackpad/keyboard already
 * work via native overflow-x + scroll-snap). This just adds optional arrow
 * buttons for mouse users and keeps their disabled state in sync with
 * actual scroll position.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-rc-carousel-track]').forEach((track) => {
    const section = track.closest('[data-rc-section]');
    if (!section) return;

    const prevBtn = section.querySelector('[data-rc-carousel-prev]');
    const nextBtn = section.querySelector('[data-rc-carousel-next]');
    if (!prevBtn || !nextBtn) return;

    function slideWidth() {
      const firstSlide = track.querySelector('.rc-carousel-section__slide');
      if (!firstSlide) return track.clientWidth;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.gap || style.columnGap || '0');
      return firstSlide.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    }

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });

    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            updateArrowState();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  });
})();
